import logo from "assets/images/logo-bn.png";
import flow from "lodash/flow";
import { Children } from "react";
import { LightButton } from "../../../../components/buttons/buttons";
import Modal from "../../../../components/modals/modal/modal";
import { currencyFormat, nullary } from "../../../../core/utils";
import { ModalProps } from "../../../../core/utils/modals";
import { DatosComprobante } from "../types/pagos.types";
import "./comprobante-pago.modal.scss";

export type ComprobantePagoModalProps = ModalProps & {
	datos?: Partial<DatosComprobante>;
	descargarComprobante: VoidFunction;
};

const ComprobantePagoModal = ({ parent, datos = {}, descargarComprobante }: ComprobantePagoModalProps) => {
	const footer = (close: VoidFunction) => (
		<>
			<LightButton className="me-5" onClick={nullary(flow(descargarComprobante, close))}>Descargar</LightButton>
			<LightButton className="ml-5" onClick={nullary(flow(window.print, close))}>Imprimir</LightButton>
		</>
	);

	return (
		<Modal parent={parent} title="" dialogClassName="comprobante-pago" footer={footer}>
			<div className="col-12">
				<div className="comprobante-banorte">
					<div className="c-header">
						<img src={logo} alt="alt" height="60px" />
					</div>
					<div className="c-body">
						<table className="border-b">
							<tbody>
								<tr>
									<td>Empresa:</td>
									<td>{datos.nombre}</td>
								</tr>
								<tr>
									<td>RFC de la empresa:</td>
									<td>{datos.rfc}</td>
								</tr>
								<tr>
									<td>Fecha de operación:</td>
									<td>{datos.fechaOperacion}</td>
								</tr>
								<tr>
									<td>Hora de operación:</td>
									<td>{datos.horaOperacion}</td>
								</tr>
								<tr>
									<td>Forma de pago:</td>
									<td>{datos.formaPago}</td>
								</tr>
								<tr>
									<td>Cuenta origen:</td>
									<td>{datos.cuentaOrigen}</td>
								</tr>
								<tr>
									<td>Cuenta destino:</td>
									<td>{datos.cuentaDestino}</td>
								</tr>
								<tr>
									<td>Banco destino:</td>
									<td>{datos.bancoDestino}</td>
								</tr>
								<tr>
									<td>Importe:</td>
									<td>{currencyFormat(datos.importe ?? 0)} MN</td>
								</tr>
								<tr>
									<td>ID de cobro:</td>
									<td>
										{Children.toArray(datos.referencias?.map(referencia =>
											<>{referencia}<br /></>
										))}
									</td>
								</tr>
								<tr>
									<td>Concepto de pago:</td>
									<td>
										{Children.toArray(datos.conceptos?.map((concepto, i) =>
											<>{concepto}<br /></>
										))}
									</td>
								</tr>
								<tr>
									<td>Clave de rastreo:</td>
									<td>{datos.claveRastreo}</td>
								</tr>
								<tr>
									<td>Referencia de pago:</td>
									<td>{datos.referenciaPago}</td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>
			</div>
		</Modal>
	);
};

export default ComprobantePagoModal;